<template>
  <b-input-group size="sm">
    <datepicker
      id="order-date-input"
      ref="createdDateCalendar"
      v-model="date"
      class="rp-datepicker"
      format="dd.MM.yyyy"
      :language="languages[lng]"
      :bootstrap-styling="true"
      :typeable="true"
      input-class="form-control form-control-sm"
      calendar-class="rp-calendar"
      @input="updateValue"
    />
    <b-input-group-append>
      <b-button
        variant="outline-primary"
        class="btn-calendar-addon"
        @click="openCalendar('createdDateCalendar')"
      >
        <img :src="calendarIcon">
      </b-button>
    </b-input-group-append>
    <b-form-input
      id="order-datetime-input"
      v-model="timeString"
      type="text"
      placeholder="HH:mm"
      @input="updateTime"
    />
    <b-input-group-append>
      <b-form-timepicker
        v-model="timeString"
        button-only
        right
        locale="de"
        button-variant="outline-primary"
        close-button-variant="outline-primary"
        aria-controls="order-datetime-input"
        size="sm"
        @input="updateTime"
      />
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import {de, en} from 'vuejs-datepicker/dist/locale';
import calendarIcon from '../../assets/icons/calendar.svg';
import {BFormTimepicker} from 'bootstrap-vue';

export default {
  name: 'DateTimePicker',
  components: {'datepicker': Datepicker, 'b-form-timepicker': BFormTimepicker},
  props: {
    value: {
      type: Date,
      default: () => Date.now()
    }
  },
  data: function () {
    return {
      languages: {
        de,
        en
      },
      calendarIcon,
      date: null,
      timeString: null,
      dateString: null
    };
  },
  mounted() {
    this.date = this.value.getTime();
    if (this.date) {
      this.timeString = moment(this.date).format('HH:mm');
    }
  },
  methods: {
    openCalendar(ref) {
      this.$refs[ref].showCalendar();
    },
    updateTime(value) {
      if (value) {
        const time = moment(value, 'HH:mm');
        this.date = moment(this.date).set({
          hour: time.hours(),
          minute: time.minutes(),
        }).toDate();
        this.$emit('input', this.date);
      }
    },
    updateValue(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style scoped lang="scss">
  .rp-datepicker {
    flex-grow: 1.2;
    flex-basis: 0%;
  }

  ::v-deep   .input-group-append button {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
  }
</style>
